import React, { useState } from 'react';
import { ClockIcon, EyeIcon, MousePointerIcon, BarChart3Icon, MousePointerClickIcon, TimerIcon, PercentIcon, WifiIcon, GaugeIcon, FanIcon } from 'lucide-react';
interface PageAnalysisProps {
  openHeatmap: () => void;
}
export const PageAnalysis: React.FC<PageAnalysisProps> = ({
  openHeatmap
}) => {
  const [activeTab, setActiveTab] = useState('forside');
  const tabs = [{
    id: 'forside',
    label: 'Forside'
  }, {
    id: 'sammenligning',
    label: 'Sammenligning'
  }, {
    id: 'materialeliste',
    label: 'Materialeliste'
  }, {
    id: 'fragt',
    label: 'Fragt & Rabatter'
  }, {
    id: 'tco',
    label: 'TCO/ROI'
  }, {
    id: 'accept',
    label: 'Accept'
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5 mb-6" data-id="element-293">
      <h2 className="text-lg font-medium mb-4 truncate" data-id="element-294">Sideanalyse</h2>
      <div className="border-b border-gray-200" data-id="element-295">
        <div className="flex overflow-x-auto" data-id="element-296">
          {tabs.map(tab => <button key={tab.id} className={`py-2 px-3 text-sm font-medium whitespace-nowrap ${activeTab === tab.id ? 'border-b-2 border-red-600 text-red-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab(tab.id)} data-id="element-297">
              {tab.label}
            </button>)}
        </div>
      </div>
      <div className="pt-4" data-id="element-298">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-299">
          <div className="grid grid-cols-2 gap-4" data-id="element-300">
            {/* Tid på side */}
            <div className="bg-gray-50 p-3 rounded-lg" data-id="element-301">
              <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-302">
                <TimerIcon size={14} className="flex-shrink-0" data-id="element-303" />
                <span className="truncate" data-id="element-304">Tid på side</span>
              </div>
              <div className="font-medium" data-id="element-305">02:41</div>
              <div className="text-xs text-gray-500 mt-1 truncate" data-id="element-306">
                80% bruger: 03:15
              </div>
            </div>
            {/* Visninger */}
            <div className="bg-gray-50 p-3 rounded-lg" data-id="element-307">
              <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-308">
                <EyeIcon size={14} className="flex-shrink-0" data-id="element-309" />
                <span className="truncate" data-id="element-310">Visninger</span>
              </div>
              <div className="font-medium" data-id="element-311">12</div>
              <div className="text-xs text-gray-500 mt-1 truncate" data-id="element-312">
                Unikke: 5
              </div>
            </div>
            {/* Scroll-dybde */}
            <div className="bg-gray-50 p-3 rounded-lg col-span-2" data-id="element-313">
              <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-314">
                <PercentIcon size={14} className="flex-shrink-0" data-id="element-315" />
                <span className="truncate" data-id="element-316">Scroll-dybde</span>
              </div>
              <div className="h-4 bg-gray-200 rounded-full mt-2 mb-1" data-id="element-317">
                <div className="h-full bg-gradient-to-r from-blue-300 to-blue-500 rounded-full" style={{
                width: '75%'
              }} data-id="element-318"></div>
              </div>
              <div className="flex justify-between text-xs text-gray-500" data-id="element-319">
                <span data-id="element-320">0%</span>
                <span data-id="element-321">25%</span>
                <span data-id="element-322">50%</span>
                <span data-id="element-323">75%</span>
                <span data-id="element-324">100%</span>
              </div>
            </div>
            {/* CTA-klik */}
            <div className="bg-gray-50 p-3 rounded-lg col-span-2" data-id="element-325">
              <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-326">
                <MousePointerClickIcon size={14} className="flex-shrink-0" data-id="element-327" />
                <span className="truncate" data-id="element-328">CTA-klik</span>
              </div>
              <div className="space-y-2 mt-2" data-id="element-329">
                <div className="flex justify-between items-center text-xs" data-id="element-330">
                  <span className="truncate mr-2" data-id="element-331">"Vælg denne løsning"</span>
                  <span className="font-medium whitespace-nowrap" data-id="element-332">8</span>
                </div>
                <div className="flex justify-between items-center text-xs" data-id="element-333">
                  <span className="truncate mr-2" data-id="element-334">"Download PDF"</span>
                  <span className="font-medium whitespace-nowrap" data-id="element-335">3</span>
                </div>
                <div className="flex justify-between items-center text-xs" data-id="element-336">
                  <span className="truncate mr-2" data-id="element-337">"Se vilkår"</span>
                  <span className="font-medium whitespace-nowrap" data-id="element-338">1</span>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-4" data-id="element-339">
            {/* Heatmap thumbnail */}
            <div className="bg-gray-50 p-3 rounded-lg" data-id="element-340">
              <div className="text-sm text-gray-500 mb-2 flex items-center justify-between" data-id="element-341">
                <div className="flex items-center gap-1" data-id="element-342">
                  <MousePointerIcon size={14} className="flex-shrink-0" data-id="element-343" />
                  <span className="truncate" data-id="element-344">Klik- & muse-heatmap</span>
                </div>
                <button className="text-xs text-red-600 flex items-center gap-1 hover:underline whitespace-nowrap ml-2" onClick={openHeatmap} data-id="element-345">
                  Åbn heatmap
                </button>
              </div>
              <div className="bg-gray-200 rounded-lg h-32 flex items-center justify-center" data-id="element-346">
                <div className="text-center" data-id="element-347">
                  <div className="w-16 h-16 mx-auto bg-gradient-to-r from-yellow-200 via-red-500 to-red-500 rounded-full opacity-50" data-id="element-348"></div>
                  <span className="text-xs text-gray-500" data-id="element-349">Heatmap preview</span>
                </div>
              </div>
            </div>
            {/* Interesse pr. kategori */}
            <div className="bg-gray-50 p-3 rounded-lg" data-id="element-350">
              <div className="text-sm text-gray-500 mb-2 flex items-center gap-1" data-id="element-351">
                <BarChart3Icon size={14} className="flex-shrink-0" data-id="element-352" />
                <span className="truncate" data-id="element-353">Interesse pr. kategori</span>
              </div>
              <div className="space-y-2" data-id="element-354">
                <div className="flex items-center gap-2" data-id="element-355">
                  <WifiIcon size={14} className="text-gray-400 flex-shrink-0" data-id="element-356" />
                  <span className="text-xs w-24 truncate" data-id="element-357">Styring/WiFi</span>
                  <div className="flex-1 h-2 bg-gray-200 rounded-full" data-id="element-358">
                    <div className="h-full bg-blue-400 rounded-full" style={{
                    width: '80%'
                  }} data-id="element-359"></div>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-360">
                  <div size={14} className="text-gray-400 flex-shrink-0" data-id="element-361" />
                  <span className="text-xs w-24 truncate" data-id="element-362">Rør/Manifolder</span>
                  <div className="flex-1 h-2 bg-gray-200 rounded-full" data-id="element-363">
                    <div className="h-full bg-blue-400 rounded-full" style={{
                    width: '45%'
                  }} data-id="element-364"></div>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-365">
                  <GaugeIcon size={14} className="text-gray-400 flex-shrink-0" data-id="element-366" />
                  <span className="text-xs w-24 truncate" data-id="element-367">
                    Fordelere/ventiler
                  </span>
                  <div className="flex-1 h-2 bg-gray-200 rounded-full" data-id="element-368">
                    <div className="h-full bg-blue-400 rounded-full" style={{
                    width: '30%'
                  }} data-id="element-369"></div>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-370">
                  <FanIcon size={14} className="text-gray-400 flex-shrink-0" data-id="element-371" />
                  <span className="text-xs w-24 truncate" data-id="element-372">Ventilation</span>
                  <div className="flex-1 h-2 bg-gray-200 rounded-full" data-id="element-373">
                    <div className="h-full bg-blue-400 rounded-full" style={{
                    width: '65%'
                  }} data-id="element-374"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};